/* eslint-disable camelcase */
export enum InvoiceMissionTypeTextEnum {
  unknown = 'unknown',
  autogiro = 'autogiro',
  buy = 'buy',
  card = 'card',
  card2 = 'card2',
  einvoice = 'einvoice',
  gift = 'gift',
  gift_recurring = 'gift_recurring',
  local = 'local',
  member = 'member',
  sms = 'sms',
  subscription = 'subscription',
}

export const GetInvoiceMissionTypeDescription = (type: keyof typeof InvoiceMissionTypeTextEnum, t: (n: string) => string): string => {
  switch (type) {
    case InvoiceMissionTypeTextEnum.unknown:
      return t('invoice:invoiceMissionTypeText.unknown');

    case InvoiceMissionTypeTextEnum.autogiro:
      return t('invoice:invoiceMissionTypeText.autogiro');
    case InvoiceMissionTypeTextEnum.buy:
      return t('invoice:invoiceMissionTypeText.buy');
    case InvoiceMissionTypeTextEnum.card:
      return t('invoice:invoiceMissionTypeText.card');
    case InvoiceMissionTypeTextEnum.card2:
      return t('invoice:invoiceMissionTypeText.card2');
    case InvoiceMissionTypeTextEnum.einvoice:
      return t('invoice:invoiceMissionTypeText.einvoice');
    case InvoiceMissionTypeTextEnum.gift:
      return t('invoice:invoiceMissionTypeText.gift');
    case InvoiceMissionTypeTextEnum.gift_recurring:
      return t('invoice:invoiceMissionTypeText.gift_recurring');
    case InvoiceMissionTypeTextEnum.local:
      return t('invoice:invoiceMissionTypeText.local');
    case InvoiceMissionTypeTextEnum.member:
      return t('invoice:invoiceMissionTypeText.member');
    case InvoiceMissionTypeTextEnum.sms:
      return t('invoice:invoiceMissionTypeText.sms');
    case InvoiceMissionTypeTextEnum.subscription:
      return t('invoice:invoiceMissionTypeText.subscription');
    default:
      return t('invoice:invoiceMissionTypeText.defaultUnknown');
  }
};
